<div #pdfArea class="min-h-screen bg-white font-sans text-slate-800">
    <header class="bg-resume-teal text-white px-8 py-10 md:py-12">
        <div class="max-w-6xl mx-auto">
            <h1 class="text-4xl md:text-6xl font-bold mb-2 tracking-tight">Burakhan Şamlı</h1>
            <p class="text-xl md:text-2xl font-light text-resume-teal-light mb-6">Adli Bilişim Mühendisi | AI, CV, NLP & MLOps
            </p>

            <p class="text-sm md:text-base leading-relaxed opacity-90 mb-8 max-w-4xl">
                &nbsp;&nbsp;Adli Bilişim Mühendisliği altyapısına sahip bir Yapay Zeka Uzmanı (AI Specialist) olarak;
                Bilgisayarlı Görü (Computer Vision), Doğal Dil İşleme (Natural Language Processing) ve
                Uzaktan Algılama (Remote Sensing) tabanlı yapay zeka sistemleri üzerine çalışmaktayım.

                Gerçek dünya uygulamalarına yönelik olarak; biyometrik kimliklendirme,
                nesne tespiti ve takibi (object detection & tracking), çok kameralı video analitiği
                ve uydu görüntüsü analizi gibi alanlarda uçtan uca ve ölçeklenebilir yapay zeka çözümleri geliştirme
                deneyimine sahibim.

                Görüntü ve dil alanlarında Transformer tabanlı mimariler ile uygulamalı güçlü bir tecrübeye sahip olup,
                geliştirdiğim yapay zeka modellerini Docker ve Kubernetes kullanarak konteyner tabanlı ve
                mikroservis mimarileri üzerinde üretim ortamlarına taşımaktayım.
            </p>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm font-medium">
                <div class="flex items-center gap-2 hover:text-white/80 transition-colors">
                    <lucide-icon [img]="MailIcon" class="my-icon"></lucide-icon>
                    <a href="mailto:burakhansamli@proton.me">burakhansamli@proton.me</a>
                </div>
                <div class="flex items-center gap-2 hover:text-white/80 transition-colors">
                    <lucide-icon [img]="PhoneIcon" class="my-icon"></lucide-icon>
                    <span><a [href]="'tel:'+tel">{{ tel }}</a></span>
                </div>
                <div class="flex items-center gap-2 hover:text-white/80 transition-colors">
                    <lucide-icon [img]="MapPinIcon" class="my-icon"></lucide-icon>
                    <span>Ankara</span>
                </div>
                <div class="flex items-center gap-2 hover:text-white/80 transition-colors">
                    <lucide-icon [img]="LinkedInIcon" class="my-icon"></lucide-icon>
                    <a href="https://www.linkedin.com/in/burakhan-şamlı-0000/">Burakhan Şamlı</a>
                </div>
                <div class="flex items-center gap-2 hover:text-white/80 transition-colors">
                    <lucide-icon [img]="GithubIcon" class="my-icon"></lucide-icon>
                    <a href="https://github.com/blitzkrieg0000">github.com/blitzkrieg0000</a>
                </div>
                <div class="flex items-center gap-2 hover:text-white/80 transition-colors">
                    <lucide-icon [img]="GlobeIcon" class="my-icon"></lucide-icon>
                    <a href="https://blitzkrieg0000.github.io/">https://blitzkrieg0000.github.io/</a>
                </div>
            </div>
        </div>
    </header>

    <main class="max-w-6xl mx-auto px-8 py-12 grid grid-cols-1 md:grid-cols-12 gap-12">
        <!-- Column 0 -->
        <div class="md:col-span-7 lg:col-span-8 space-y-10">
            <!-- CV -->
            <section>
                <div>
                    <h2 class="text-resume-gold text-2xl font-bold uppercase border-b-2 border-resume-gold/30 pb-2 mb-2 tracking-wide">İŞ DENEYİMİ</h2>
                    <div class="space-y-8 relative pl-4 border-l-2 border-slate-300 ml-2">
                        <div class="relative mb-2">
                            <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-gold border-4 border-white shadow-sm"></div>
                            <div class="flex justify-between items-baseline mb-1">
                                <h3 class="text-xl font-bold text-slate-900">Hexaops A.Ş.</h3>
                                <span class="text-sm italic text-slate-500">Teknokent, Kahramanmaraş</span>
                                <span class="text-xs font-semibold text-resume-teal-dark bg-resume-teal/10 px-2 py-0.5 rounded">10/2024 - 05/2025</span>
                            </div>
                        </div>

                        <div class="space-y-8 relative pl-4 border-l-2 border-slate-200 ml-0">
                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-3">
                                    <h4 class="text-lg font-semibold text-slate-700">Yapay Zeka Mühendisi ve Yazılım Geliştirici</h4>
                                </div>
                                <ul class="list-disc list-outside ml-4 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                    <li>Makine Çevirisi (Machine Translation) odaklı LLM fine-tuning süreçlerine katkı sağladım.</li>
                                    <li>Üretim (production) ortamlarında Text-to-Speech (TTS), Speech-to-Text (STT) ve voice cloning (ses klonlama) iş akışlarının geliştirilmesine ve iyileştirilmesine mühendislik desteği verdim.</li>
                                    <li>Sınırlı GPU kaynakları üzerinde LLM fine-tuning yapılabilmesini sağlamak amacıyla Fully Sharded Data Parallel (FSDP) tabanlı dağıtık model eğitim tekniklerini uyguladım.</li>
                                    <li>Bellek kullanımı (memory footprint), eğitim süresi ve toplam hesaplama maliyetlerini azaltarak eğitim verimliliğini artırdım.</li>
                                </ul>
                            </div>
                        </div>

                        <div class="relative mb-2">
                            <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-gold border-4 border-white shadow-sm"></div>
                            <div class="flex justify-between items-baseline mb-1">
                                <h3 class="text-xl font-bold text-slate-900">DGH Arge Yazılım LTD.</h3>
                                <span class="text-sm italic text-slate-500">ASBÜ Teknokent, Ankara</span>
                                <span class="text-xs font-semibold text-resume-teal-dark bg-resume-teal/10 px-2 py-0.5 rounded">08/2021 - 10/2024</span>
                            </div>
                        </div>

                        <div class="space-y-8 relative pl-4 border-l-2 border-slate-200 ml-0">
                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-1">
                                    <h4 class="text-lg font-semibold text-slate-700">Uzaktan Algılama (Remote Sensing) & CBS (GIS) Geliştirici</h4>
                                </div>

                                <ul class="list-disc list-outside ml-4 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                    <li>
                                        Multispektral ve hiperspektral uzaktan algılama verilerini kullanarak uydu görüntüsü analizi ve Coğrafi Bilgi Sistemleri (CBS) tabanlı iş akışları gerçekleştirdim. </li>
                                    <li>
                                        Arazi Kullanımı / Arazi Örtüsü (Land Use and Land Cover) sınıflandırması ve analizi dahil olmak üzere, tarım odaklı uzaktan algılama projelerinde teknikler uyguladım.
                                    <li>
                                        Sentinel, Landsat, Google Earth Engine (GEE), ArcGIS Pro ve Copernicus veri setleri gibi uydu platformları ve jeo-uzamsal araçlarla aktif olarak çalıştım.
                                    <li>
                                        Gerçek dünya CBS ve çevresel uygulamalarını desteklemek amacıyla uydu görüntülerinin ön işleme (preprocessing), analiz ve yorumlama süreçlerini yürüttüm.
                                    </li>
                                </ul>
                            </div>


                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-1">
                                    <h4 class="text-lg font-semibold text-slate-700">Doğal Dil İşleme & Transformer Model Geliştirici</h4>
                                </div>

                                <ul class="list-disc list-outside ml-4 mt-2 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                    <li>Doğal Dil İşleme (Natural Language Processing - NLP) ve Bilgisayarlı Görü (Computer Vision) alanlarında Transformer tabanlı mimariler geliştirerek projelere uygun hale getirdim.</li>
                                    <li>Metin tabanlı analiz, özellik temsili (feature representation) ve modern derin öğrenme iş akışları için Transformer modellerini eğitimleri yaptım.</li>
                                    <li>Bilgisayarlı görü projelerinde, Transformer tabanlı yaklaşımları (DETR, VIT) entegre ederek aktif rol aldım.</li>
                                </ul>
                            </div>

                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-1">
                                    <h3 class="text-lg font-semibold text-slate-700">Araştırmacı & İleri Sistemler</h3>
                                </div>
                                <ul class="list-disc list-outside ml-4 mt-2 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                    <li>Huawei Atlas 800 sunucuları üzerinde, NPU acceleration desteğiyle Docker tabanlı ortamlarda YOLO tabanlı mimariler kullanarak hata tespiti (fault detection) için deep learning modelleri eğittim.</li>
                                    <li>Computer Vision tabanlı altyapı hata tespit sistemleri için sunucu tarafı AI eğitim iş akışlarını (training workflows) geliştirdim ve yönettim.</li>
                                    <li>Yapay zeka sistemlerinin yönetimi ve veri iş akışlarını desteklemek amacıyla ASP.NET Core kullanarak backend odaklı web uygulamaları tasarladım ve hayata geçirdim.</li>
                                    <li>Çevresel ve tarım odaklı senaryolar için uzaktan algılama (remote sensing) alanında uygulamalı araştırmalar yürüttüm.</li>
                                </ul>
                            </div>

                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-1">
                                    <h4 class="text-lg font-semibold text-slate-700">Yapay Zeka ve Bilgisayarlı Görü (CV) Mühendisi</h4>
                                </div>
                                <ul class="list-disc list-outside ml-4 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                    <li>OpenCV ve deep learning teknikleri kullanarak; OCR, image segmentation, object detection ve multi-object tracking gibi alanlarda AI tabanlı görüntü işleme ve bilgisayarlı görü uygulamaları geliştirdim.</li>
                                    <li>Supervised deep learning iş akışlarını desteklemek amacıyla veri hazırlama (data preparation), etiketleme (labeling) ve veri artırma (augmentation) süreçlerini kapsayan veri setleri oluşturdum ve yönettim.</li>
                                    <li>GAN ve Transformer tabanlı görüntü iyileştirme tekniklerini; super-resolution ve feature representation learning gibi yaklaşımlar üzerinden uyguladım.</li>
                                    <li>Gerçek zamanlı (real-time) AI sistemleri tasarlayıp hayata geçirdim; bu kapsamda kalite kontrol pipeline'ları, face recognition ve identification platformları ile yüksek gerilim iletim hatlarında hata tespiti (fault detection) içeren altyapı denetim çözümleri geliştirdim.</li>
                                    <li>PyTorch kullanarak derin öğrenme modelleri geliştirdim ve bu modelleri NVIDIA Triton Inference Server ve TorchServe üzerinden inference servisleri olarak dağıttım.</li>
                                </ul>
                            </div>

                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-1">
                                    <h3 class="text-lg font-semibold text-slate-700">MLOps ve Backend Geliştirici</h3>
                                </div>
                                <ul class="list-disc list-outside ml-4 mt-2 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                    <li>Python ve FastAPI kullanarak yapay zeka odaklı backend servisleri geliştirdim; model çıkarım (inference) süreçlerini NVIDIA Triton Inference Server üzerinden servis ettim.</li>
                                    <li>Ölçeklenebilir ve modüler yazılım sistemlerini desteklemek amacıyla mikroservis tabanlı mimariler tasarladım ve uyguladım.</li>
                                    <li>Uygulamaları Docker, Kubernetes ve Proxmox kullanarak konteynerleştirdim; orkestrasyon ve sanallaştırma süreçlerini yönettim.</li>
                                    <li>GitHub Actions, GHCR, ArgoCD ve Ansible kullanarak CI/CD pipeline'ları oluşturdum ve dağıtım (deployment) süreçlerini otomatikleştirdim.</li>
                                    <li>Kafka, Redis ve RTMP tabanlı streaming sistemleri ile gerçek zamanlı veri işleme pipeline'ları geliştirdim.</li>
                                    <li>Sistem performansı ve servis sürekliliğini Prometheus ve Grafana ile izledim ve takip ettim.</li>
                                </ul>
                            </div>
                        </div>

                        <div class="relative  mb-2">
                            <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-gold border-4 border-white shadow-sm"></div>
                            <div class="flex justify-between items-baseline mb-1">
                                <h3 class="text-xl font-bold text-slate-900">Adli Bilişim Mühendisliği Stajı - I</h3>
                                <span class="text-xs font-semibold text-resume-teal-dark bg-resume-teal/10 px-2 py-0.5 rounded">07/2021 - 08/2021</span>
                            </div>

                        </div>

                        <div class="space-y-8 relative pl-4 border-l-2 border-slate-200 ml-0">
                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-3">
                                    <h4 class="text-lg font-semibold text-slate-700">DGH Arge Yazılım</h4>
                                    <span class="text-sm italic text-slate-500">İnönü Teknokent, Malatya</span>
                                </div>
                                <div>
                                    <ul class="list-disc list-outside ml-4 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                        <li>Python, PyTorch, TensorFlow ve OpenCV kullanarak AI tabanlı yazılım geliştirme süreçlerinde temel düzeyde deneyim kazandım.</li>
                                        <li>ASP.NET Core kullanılarak geliştirilen backend servislerin oluşturulmasına ve Vue.js tabanlı frontend bileşenlerin entegrasyonuna destek verdim.</li>
                                        <li>Web tabanlı uygulamalar için Socket.IO kullanarak gerçek zamanlı iletişim (real-time communication) mekanizmalarını inceledim ve uyguladım.</li>
                                        <li>Kısa süreli staj projeleri kapsamında gerçek zamanlı web entegrasyonu çalışmalarına destek sağladım.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="relative  mb-2">
                            <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-gold border-4 border-white shadow-sm"></div>
                            <div class="flex justify-between items-baseline mb-1">
                                <h3 class="text-xl font-bold text-slate-900">Adli Bilişim Mühendisliği Stajı - II</h3>
                                <span class="text-xs font-semibold text-resume-teal-dark bg-resume-teal/10 px-2 py-0.5 rounded">07/2020 - 08/2020</span>
                            </div>
                        </div>

                        <div class="space-y-8 relative pl-4 border-l-2 border-slate-200 ml-0">
                            <div class="relative">
                                <div class="absolute -left-[23px] top-2 w-3 h-3 rounded-full bg-resume-teal border-3 border-white shadow-sm"></div>
                                <div class="flex justify-between items-baseline mb-3">
                                    <h4 class="text-lg font-semibold text-slate-700">Telehouse İstanbul - Teknotel</h4>
                                    <span class="text-sm italic text-slate-500">Kozyatağı, Kadıköy/İstanbul</span>
                                </div>
                                <div>
                                    <ul class="list-disc list-outside ml-4 space-y-2 text-sm text-slate-600 marker:text-resume-teal">
                                        <li>Cisco Packet Tracer kullanarak yönlendirme (routing) ve ağ protokollerine yönelik temel network altyapı çalışmalarında görev aldım.</li>
                                        <li>HP kurumsal sunucular üzerinde sunucu kurulumu ve yapılandırma süreçlerine destek verdim; SAS disk yapılandırması ve RAID birleştirme işlemlerinde yer aldım.</li>
                                        <li>REST tabanlı mimariler ve web hosting sistemleri üzerine pratik deneyim kazandım; WHMCS tabanlı servis ve müşteri yönetim iş akışlarını inceledim.</li>
                                        <li>Sunucu, depolama ve bağlantı yönetimini kapsayan network ve IT operasyonlarına destek sağladım.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Projects -->
            <section>
                <h2 class="text-resume-gold text-2xl font-bold uppercase border-b-2 border-resume-gold/30 pb-2 mb-2 tracking-wide">Projeler</h2>
                <div class="space-y-8 relative pl-4 border-l-2 border-slate-200 ml-2">
                    <div class="relative">
                        <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-teal border-4 border-white shadow-sm"></div>
                        <h3 class="text-lg font-bold text-slate-900 mb-0 mt-1">LULC Analizi & Uzaktan Algılama (Remote Sensing)</h3>
                        <ul class="list-disc list-outside ml-4 text-md text-slate-600 marker:text-resume-teal">
                            <li>
                                Multispektral Sentinel-2 ve Landsat uydu görüntülerini kullanarak Arazi Kullanımı ve Arazi Örtüsü (Land Use and Land Cover) segmentasyonu gerçekleştirdim.
                            </li>
                            <li>
                                ArcGIS Pro ve QGIS kullanarak bileşik veri setleri (composite datasets) oluşturdum; arazi örtüsü sınıflarının alan dağılımlarını hesaplamak için coğrafi analizler yaptım.
                            </li>
                            <li>
                                Google Earth Engine (GEE) API'leri ve Copernicus veri setleri üzerinden, LULC analizine yönelik ölçeklenebilir veri toplama ve işleme pipeline'ları geliştirdim.
                            </li>
                            <li>
                                Web tabanlı jeo-uzamsal protokoller aracılığıyla map tile verilerini çekip işleyerek, büyük ölçekli mekansal analiz iş akışlarını destekledim.
                            </li>
                            <li>
                                Radar verileri üzerinden InSAR tabanlı teknikler kullanarak Sayısal Yükseklik Modelleri (Digital Elevation Model - DEM) ürettim ve arazi/yükseklik analizleri gerçekleştirdim.
                            </li>
                        </ul>
                    </div>

                    <div class="relative">
                        <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-teal border-4 border-white shadow-sm"></div>
                        <h3 class="text-lg font-bold text-slate-900 mb-0 mt-1">Hata Tespiti Projesi - Yüksek Gerilim İletim Hatları</h3>
                        <ul class="list-disc list-outside ml-4 text-md text-slate-600 marker:text-resume-teal">
                            <li>
                                YOLOv11 tabanlı object detection ve segmentation modelleri kullanarak yüksek gerilim iletim hatları için computer vision tabanlı hata tespit sistemi geliştirdim.
                            </li>
                            <li>
                                İzolatörler (insulators), direkler (poles) ve diğer yapısal bileşenleri kapsayan tespit ve segmentasyon pipeline'ları tasarladım ve uyguladım.
                            </li>
                            <li>
                                Altyapı güvenliği ve proaktif bakım süreçlerini desteklemek amacıyla, iletim hatları üzerindeki kuş yuvalarının tespiti için object detection modelleri geliştirdim.
                            </li>
                            <li>
                                Model eğitimi ve değerlendirmesi için özel veri setleri hazırladım; veri etiketleme (annotation) ve kalite kontrol süreçlerini yönettim.
                            </li>
                        </ul>
                    </div>

                    <div class="relative">
                        <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-teal border-4 border-white shadow-sm"></div>

                        <h3 class="text-lg font-bold text-slate-900 mb-0 mt-1">
                            Çoklu Kamera Tabanlı AI Güvenlik & Gözetim Sistemi
                        </h3>

                        <ul class="list-disc list-outside ml-4 text-md text-slate-600 marker:text-resume-teal">
                            <li>
                                Yüz tespiti, yüz tanıma, çoklu obje takibi ve kişi yeniden-tanımlama (person re-identification) bileşenlerini bir araya getirerek kimlik tabanlı gözetim senaryoları için entegre bir bilgisayarlı görü sistemi geliştirdim.
                            </li>
                            <li>
                                Güvenlik izleme kabiliyetlerini artırmak amacıyla maske tespiti(COVID-19), duygu tanıma ve silah tespiti gibi ek AI modüllerini sisteme entegre ettim.
                            </li>
                            <li>
                                Sistemi, birden fazla kamera akışı üzerinde gerçek zamanlı video işleme ve olay tabanlı analitik yapabilecek şekilde tasarladım.
                            </li>
                            <li>
                                Mikroservis tabanlı bir backend mimarisi kurguladım; AI inference servislerini Docker ve Kubernetes kullanarak ölçeklenebilir ve hataya dayanıklı biçimde dağıttım.
                            </li>
                            <li>
                                Dağıtık sistem bileşenleri arasında video stream yönetimi, inference servisleri ve sistem koordinasyonunu sağlayan gRPC backend API'leri geliştirdim.
                            </li>
                        </ul>
                    </div>

                    <div class="relative">
                        <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-teal border-4 border-white shadow-sm"></div>

                        <h3 class="text-lg font-bold text-slate-900 mb-0 mt-1">
                            Gerçek Zamanlı Tenis Performans Analiz Sistemi
                        </h3>
                        <ul class="list-disc list-outside ml-4 text-md text-slate-600 marker:text-resume-teal">
                            <li>
                                ITN (International Tennis Number) performans değerlendirmesini desteklemek amacıyla; tenis topu tespiti (ball detection), takibi (tracking) ve sekme noktası tahmini (bounce point estimation) yapan gerçek zamanlı bir computer vision sistemi geliştirdim.
                            </li>
                            <li>
                                Canlı oyun sırasında vuruş (shot) olaylarını analiz etmek ve oyuncu aksiyonlarını skorlamak için oyuncu tespiti ve takip (player detection & tracking) pipeline'ları uyguladım.
                            </li>
                            <li>
                                Farklı kamera açıları üzerinden top yörüngelerini birleştirmek amacıyla çoklu kamera kalibrasyonu, hizalama (alignment) ve senkronizasyon mekanizmaları tasarladım.
                            </li>
                            <li>
                                Oyuncu hareketlerini analiz etmek ve performans gelişimini değerlendirmek için insan iskelet tahmini (human pose estimation) tekniklerini; vücut duruşu (posture) ve hareket paternleri üzerinden uyguladım.
                            </li>
                            <li>
                                Spor performans analiz sistemlerinde gerçek zamanlı geri bildirim sağlamak amacıyla düşük gecikmeli (low-latency) işleme iş akışları oluşturdum.
                            </li>
                        </ul>
                    </div>

                    <div class="relative">
                        <div class="absolute -left-[25px] top-1 w-4 h-4 rounded-full bg-resume-teal border-4 border-white shadow-sm"></div>

                        <h3 class="text-lg font-bold text-slate-900 mb-0 mt-1">Olay Raporlama Süreçlerinin Blok Zinciri ile Korunması</h3>
                        <ul class="list-disc list-outside ml-4 text-md text-slate-600 marker:text-resume-teal">
                            <li>
                                Dijital adli bilişim süreçlerinde veri işleme ve raporlama pipeline'larının değiştirilemezliğini (immutability) ve tutarlılığını sağlamak amacıyla blockchain tabanlı bir sistem tasarladım ve geliştirdim.
                            </li>
                            <li>
                                Adli analiz iş akışları boyunca delil bütünlüğünü (evidence integrity) korumak ve yetkisiz müdahaleleri önlemek için blockchain mekanizmaları uyguladım.
                            </li>
                            <li>
                                Güvenli veri yönetimi ve denetlenebilirlik (auditability) sağlamak amacıyla sistem bileşenlerini PHP ve Java kullanarak geliştirdim.
                            </li>
                            <li>
                                Adli verilerin iş akışı boyunca tutarlılığını doğrulamak için hash tabanlı doğrulama (SHA-256 vb.) mekanizmaları entegre ettim.
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>

        <!-- Column 1 -->
        <div class="md:col-span-5 lg:col-span-4 space-y-10">
            <section>
                <h2 class="text-resume-gold text-2xl font-bold uppercase border-b-2 border-resume-gold/30 pb-2 mb-2 tracking-wide">
                    TEKNİK BECERİLER
                </h2>

                <div class="space-y-4">
                    <div *ngFor="let group of technicalSkillGroups">
                        <h3 class="text-resume-teal font-semibold mb-1 text-xs uppercase tracking-wide">
                            {{ group.title }}
                        </h3>

                        <div class="flex flex-wrap gap-2">
                            <span *ngFor="let skill of group.items" class="px-2.5 py-1 bg-slate-100 text-slate-700 text-[11px] font-bold rounded-sm border border-slate-200 print:bg-none print:border-none print:px-0 print:text-sm print:inline print:after:content-[',_'] print:last:after:content-['']">
                                {{ skill }}
                            </span>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-resume-gold text-2xl font-bold uppercase border-b-2 border-resume-gold/30 pb-2 mb-2 tracking-wide">DİL</h2>
                <div class="space-y-4">
                    <div>
                        <h3 class="text-base font-bold text-slate-800 leading-tight mb-1">İngilizce - Profesyonel Çalışma Yetkinliği</h3>
                    </div>
                    <div>
                        <h3 class="text-base font-bold text-slate-800 leading-tight mb-1">Türkçe - Ana Dil</h3>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-resume-gold text-2xl font-bold uppercase border-b-2 border-resume-gold/30 pb-2 mb-2 tracking-wide">EĞİTİM</h2>
                <div>
                    <h3 class="text-lg font-bold text-slate-900 leading-tight">Fırat Üniversitesi</h3>
                    <h4 class="text-base font-medium text-slate-700 mb-1">Adli Bilişim Mühendisliği - Lisans</h4>
                    <p class="text-md text-resume-gold font-medium"><strong>GNO:</strong> 3.73 / 4</p>
                    <p class="text-sm text-resume-teal font-medium italic">2017 - 2022</p>
                </div>
            </section>
        </div>
    </main>
</div>